import React, { useEffect } from 'react';
import { Letter } from './components/letter/Letter';
import { Advantages } from './components/adventages/Adventages';
import { advantages } from './constants';
import { Header } from './components/header/Header';
import { Footer } from './components/footer/Footer';
import { WhyLoona } from './components/whyloona/WhyLoona';
import { ReactComponent as Logo } from '../../assets/bidease/logo.svg';
import { useAppDispatch } from '../../bootstrap/hooks';
import { push } from 'connected-react-router';
import HeaderImg from '../../assets/bidease/header_img.png';
import HeaderImgMobile from '../../assets/bidease/header_img_mobile.png';
import GiftCard from '../../assets/bidease/gift_card.png';
import { MOBILE_QUERY, useMediaQuery } from '../../hooks/useMediaQuery';
import { BIDEASE_CODE } from '../redeem/code/RedeemCode.constants';
import { updateFavicons } from './utils';
import styles from './styles.module.scss';

export const Bidease = () => {
  const dispatch = useAppDispatch();
  const isLargeScreen = useMediaQuery(MOBILE_QUERY);

  const headerImage = isLargeScreen ? HeaderImg : HeaderImgMobile;

  useEffect(() => {
    updateFavicons('bidease');
  }, []);

  const handleClick = () => {
    dispatch(push(`b2b/redeem/account?c=${BIDEASE_CODE}`));
  };

  return (
    <div className={styles.wrapper}>
      <Header
        logo={<Logo />}
        headerImage={headerImage}
        handleClick={handleClick}
      />
      <Letter logo={<Logo />} companyName="Bidease" />
      <WhyLoona companyName="Bidease" />
      <Advantages adventages={advantages} />
      <Footer
        companyName="Bidease!"
        giftCard={GiftCard}
        handleClick={handleClick}
      />
    </div>
  );
};
